import { useState } from 'react'
import { Button, Card, CardContent, Typography, Box } from '@mui/material'
import { useNotify } from 'react-admin'
import { uploadRevenue } from '../../Utils/RestUtils'

function RevenueUpload() {
  const [file, setFile] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const notify = useNotify()

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!file) {
      notify('Please select a file to upload.', { type: 'warning' })
      return
    }
    setIsUploading(true)

    const formData = new FormData()
    formData.append('file', file, file.name)
    const response = await uploadRevenue(formData)

    if (response.status === 422) {
      notify(JSON.stringify(response.data), {
        type: 'error',
        autoHideDuration: 100000,
      })
    } else if (response.status === 200) {
      notify('File uploaded successfully!', { type: 'info' })
      setFile(null)
    } else {
      notify('Server error, try again later', {
        type: 'error',
      })
    }

    setIsUploading(false)
  }

  return (
    <Card sx={{ width: 400, margin: '2rem auto' }}>
      <CardContent>
        <Typography variant="h5" mb={2}>
          Revenue Upload
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Button variant="contained" component="label" disabled={isUploading}>
            Select File
            <input
              type="file"
              hidden
              onChange={(e) => {
                handleFileChange(e)
                e.target.value = null
              }}
              accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            />
          </Button>
          {file && (
            <Typography variant="body2">Selected: {file.name}</Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isUploading || !file}
          >
            {isUploading ? 'Uploading...' : 'Upload'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default RevenueUpload
